(function() {
  'use strict';

  angular
    .module('newDocument.documentCtrl', ['newDocument.boxViewer', 'newDocument.errorService', 'newDocument.boxDocumentDirective'])
    .controller('NewDocumentCtrl', NewDocumentCtrl);

  NewDocumentCtrl.$inject = ['$sce', '$scope', 'ServiceHelper', 'gettext', 'newDocumentErrorService', 'translationService'];

  function NewDocumentCtrl($sce, $scope, ServiceHelper, gettext, newDocumentErrorService, translationService) {

    var translate = translationService.sprintf;
    var translations = {
      title: translate(gettext('Unable to View Content')),
      message: translate(gettext('This content appears to be blocked by your firewall. Please contact your IT Administrator.'))
    };

    $scope.vm = {
      viewerState: {}
    };

    $scope.$watch('currentSlide', currentSlideWatcher);

    function currentSlideWatcher(slide) {
      if (!slide || !(slide.__type === 'NewMultiPageSlideInfo'))
        return;

      var pages = getPages(slide.pages);
      var params = ServiceHelper.defaultUrlParams();
      var url = 'https://' + params.host + (slide.boxAssetsUrl || '');

      var newState = {
        url: $sce.trustAsResourceUrl(url),
        enableLinks: !mfConfig.isIpad,
        plugins: {
          'mf-box-plugin': {
            onerror: onBoxViewerError
          }
        }
      };

      $scope.vm.viewerState = angular.extend(newState, pages);
    }

    function getPages(pages) {
      var page = {};
      if (pages && pages.length === 1) {
        var index = pages[0].index + 1;
        page.pageStart = index;
        page.pageEnd = index;
      }

      return page;
    }

    function onBoxViewerError(value) {
      var scope = $scope.$new();
      scope.contentErrorModal = {
        message: translate(gettext('We\'ve encountered an error loading your content.')),
        redirectToDashboard: true,
        title: translate(gettext('Error Viewing Content'))
      };

      newDocumentErrorService.showError(scope);
    }
  }
})();